import Vue from 'vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import router from '@/common/router'
import "./assets/css/globalStyle.css";
import App from './App.vue';
import store from '@/helpers/store'
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import VueGtag from "vue-gtag";
import VueToast from 'vue-toast-notification';
import smartlookClient from 'smartlook-client'
//import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-sugar.css';
import VueSanitize from 'vue-sanitize';
Vue.use(VueToast, {
    duration: 5000
})


Vue.use(VueSanitize, {
    allowedTags: [
        "address", "article", "aside", "footer", "header", "h1", "h2", "h3", "h4",
        "h5", "h6", "hgroup", "main", "nav", "section", "blockquote", "dd", "div",
        "dl", "dt", "figcaption", "figure", "hr", "li", "main", "ol", "p", "pre",
        "ul", "a", "abbr", "b", "bdi", "bdo", "br", "cite", "code", "data", "dfn",
        "em", "i", "kbd", "mark", "q", "rb", "rp", "rt", "rtc", "ruby", "s", "samp",
        "small", "span", "strong", "sub", "sup", "time", "u", "var", "wbr", "caption",
        "col", "colgroup", "table", "tbody", "td", "tfoot", "th", "thead", "tr",
    ],
    allowedAttributes: {
        a: ["href", "target"]
    },
});


if(process.env.NODE_ENV !== 'local') {
    // Configuration Vue Google Analytics
    Vue.use(VueGtag, {
        config: {id: "G-30K1DDMPZG"}
    }, router);

    // Configuration Sentry
    Sentry.init({
        Vue,
        dsn: "https://005bfdbfc85a483baaebcd87dc7b2ed7@o1038700.ingest.sentry.io/6007199",        integrations: [
            new Integrations.BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                // tracingOrigins: ["localhost", "192.168.102.100:8080", "192.168.102.100", "m3.smis.ro", /^\//],
                tracingOrigins: ["m3.smis.ro", /^\//],
            }),
        ],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
        logErrors: true
    });
}

/*if(process.env.NODE_ENV === 'production') {
    if(store.getters['auth/user'] === null || (store.getters['auth/user'] && !store.getters['auth/user'].email.includes('@smis.ro'))) {*/
        Vue.use(smartlookClient)

    /*}
}*/

Vue.config.productionTip = false
new Vue({
    router,

    store,
    render: h => h(App)
}).$mount('#app')
